import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { CommonStyles } from '../../commonInfra/styles/CommonStyles';
import { HiddenUserStyles } from '../../spacesPlatform/components/spaceComponents/SpacesStyles';
import { JumpBackInIconSize } from '../common/Constants';
import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { ContentDefinitions } from '../models/ContentDefinitions';
import { ContentType, DraftReferenceType } from '../models/Types';
import { JumpBackInViewModel } from '../viewModels/JumpBackInViewModel';
import { DraftTag } from './DraftTag';
import { NeverPublishedTag } from './NeverPublishedTag';
import { activeSectionItem, alignCenter, contentSuggestionSectionItem, contentSuggestionSectionItemIcon, jumpBackInSection, section, sectionHeader, sectionHeaderTitle, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout } from './OmniboxV2Styles';

export const JumpBackInTestId = 'JumpBackIn';

export function JumpBackIn(props: { viewModel: JumpBackInViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return viewModel.jumpBackInItems ?
        viewModel.jumpBackInItems.length > 0 &&
        <div data-tb-test-id={JumpBackInTestId} className={[section, 'tb-quicklinks-section-divider', jumpBackInSection].join(' ')}>
            <div className={sectionHeader}>
                <div className={sectionHeaderTitle}>{Messages.draftSectionTitle()}</div>
            </div>
            {
                viewModel.jumpBackInItems.map((item, index) => {
                    const contentDefinition = ContentDefinitions[ContentType.workbook];

                    return <a id={item.getIdentifier()} key={index} href={item.url} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem}
                        onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onItemClicked(item, index); }}
                        className={[sectionItem, sectionItemHorizontalLayout, contentSuggestionSectionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')}>
                        <div className={[sectionItemFixedContent, contentSuggestionSectionItemIcon].join(' ')}>
                            {item.icon({size: JumpBackInIconSize})}
                        </div>
                        <div className={[sectionItemAutoFitContent, 'abc'].join(' ')} style={{ marginLeft: 13, width: '100%' }} >
                            <div className={sectionItemHorizontalLayout}>
                                <div style={{ ...CommonStyles.Layout.TextEllipsis, maxWidth: 'calc(100% - 100px)' }}>{item.title}</div>
                                <div><DraftTag /></div>
                                {item.data.type === DraftReferenceType.UnpublishedWorkbook && <div><NeverPublishedTag /></div>}
                            </div>
                            <div style={CommonStyles.Layout.TextEllipsis}>
                                <span>{contentDefinition.getName()}</span>
                                {item.owner ? <span>&nbsp;&bull;&nbsp;</span> : null}
                                <span className={item.hiddenOwner ? HiddenUserStyles.HiddenUserClassName : ''}>{item.owner}</span>
                            </div>
                        </div>
                    </a>;
                })
            }
        </div >
        : <div className={alignCenter} style={{ height: '134px' }}>
            <ActivitySpinnerWidget
                spinnerSize={ActivitySpinnerSize.Small}
                testId={'omnibox-pending'}
            />
        </div>;
}